module.exports = __webpack_public_path__ + "img/invoice-de-female-sh.37ecf027.png";